import $ from 'jquery';
import config from './../../../config';

// Get Meetings
export function get_meetings( users ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'meetings/',
			data: {
				method: 'GET_MEETINGS',
				users: users
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_MEETINGS",
				meetings: response
			})
		})

	}
}

export function save_meetings( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'meetings/',
			data: {
				method: 'SAVE_MEETINGS',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_MEETINGS",
				meetings: response
			})
		})

	}
}

export function update_meetings( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'meetings/',
			data: {
				method: 'UPDATE_MEETINGS',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_MEETINGS",
				meetings: response
			})
		})

	}
}

export function delete_meetings( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'meetings/',
			data: {
				method: 'DELETE_MEETINGS',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_MEETINGS",
				meetings: response
			})
		})

	}
}

export function get_meetings_by_id( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'meetings/',
			data: {
				method: 'GET_MEETINGS_BY_ID',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_MEETINGS_BY_ID",
				meetings: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/meetings/actions/meetings.action.js